import { render, staticRenderFns } from "./ToggleCampus.vue?vue&type=template&id=0484dba6&"
import script from "./ToggleCampus.vue?vue&type=script&lang=js&"
export * from "./ToggleCampus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports